import 'core-js/stable';

import SpeedBump from '@/components/SpeedBump';

document.addEventListener('DOMContentLoaded', function () {
    SpeedBump.init({
        selector: `[data-js="speedbump"]`,
    });
});
